import http from 'hub-http/clients/apiClient';
export const getLatestInvites = () => {
  return http.get('invite/v3/invites/single-user/latest');
};